import { currencyFormatter } from '../../services/helperService';
import { fmtBase } from '../../utils/reports/shared';
import type { UtilizationProductRow } from '../../utils/reports/utilizationReport';
import { PRACTICE_DISH_ID, practiceDishes } from './practice/practiceGuards';
import { utilizationLinkDish, notifyUtilizationValues } from './practice/utilizationPractice';

let pageValues: Record<string, string> = {};
let product: UtilizationProductRow | null = null;
let favoriteCount = 0;
let favoriteGoal = 3;
/** Published from the same scope pipeline the visible cards and drawer consume. */
export function publishUtilizationValues(waste: number, reviews: number, row: UtilizationProductRow | null, favorites = 0, availableProducts = 3) {
  const previous = JSON.stringify(getUtilizationTourValues());
  product = row;
  favoriteCount = favorites;
  favoriteGoal = Math.min(3, availableProducts);
  pageValues = { utilWaste: currencyFormatter.format(waste), utilReviewCount: String(reviews) };
  if (previous !== JSON.stringify(getUtilizationTourValues())) queueMicrotask(notifyUtilizationValues);
}
export const utilizationWalkthroughProduct = () => product;
export const utilizationWalkthroughProductKey = () => product?.key ?? '';
export const utilizationWalkthroughProductName = () => product?.name ?? '';
export const utilizationSetupDish = () => utilizationLinkDish()?.menuItemName ?? '';
export const utilizationSetupQuery = utilizationSetupDish;
export const utilizationEditDishId = () => PRACTICE_DISH_ID;
export const utilizationEditDish = () => practiceDishes().find(d => d.id === PRACTICE_DISH_ID)?.menuItemName ?? '';
export function getUtilizationTourValues(): Record<string, string> {
  return { ...pageValues, context: product && product.wasteBase <= 0 ? 'balanced' : '', utilProduct: product?.name ?? '',
    utilOrdered: product ? fmtBase(product.orderedBase, product.stdUnit) : '',
    utilNeeded: product ? fmtBase(product.neededBase, product.stdUnit) : '',
    utilDifference: product ? fmtBase(product.wasteBase, product.stdUnit) : '',
    utilProductWaste: product?.wasteEur != null ? currencyFormatter.format(product.wasteEur) : '',
    utilUtilPct: product?.utilizationPercent != null ? `${Math.round(product.utilizationPercent * 10) / 10}%` : '',
    utilDish: utilizationSetupDish(), utilDishQuery: utilizationSetupQuery(),
    utilIngFrom: '100 g', utilIngTo: '50 g', utilEditDish: utilizationEditDish(),
    utilEditFrom: '5 g', utilEditTo: '75 g', utilFavoriteCount: String(favoriteCount), utilFavoriteGoal: String(favoriteGoal) };
}

export const utilizationFavoritesCompleted = () => favoriteGoal > 0 && favoriteCount >= favoriteGoal;
export function utilizationQuantityCompleted(kind: 'setup' | 'edit'): boolean {
  const dish = kind === 'setup' ? utilizationLinkDish() : practiceDishes().find(d => d.id === utilizationEditDishId());
  const ingredient = dish?.ingredients.find(i => i.productName === utilizationWalkthroughProductName());
  return ingredient?.quantityNeeded === (kind === 'setup' ? 50 : 75);
}
